var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Caminho_329",
  "data-name": "Caminho 329",
  d: "M7,24H9V22H7Zm4,0h2V22H11Zm4,0h2V22H15ZM16,.01,8,0A2.006,2.006,0,0,0,6,2V18a2.006,2.006,0,0,0,2,2h8a2.006,2.006,0,0,0,2-2V2A2,2,0,0,0,16,.01ZM16,16H8V4h8Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Caminho_330",
  "data-name": "Caminho 330",
  d: "M0,0H24V24H0Z",
  fill: "none"
});

var SvgIcCell = function SvgIcCell(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "settings_cell-24px",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcCell, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_cell.a24f2f90.svg";
export { ForwardRef as ReactComponent };